import {
  CloseCircleOutlined,
  FilterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, Flex, Form, Input } from 'antd';
import isEqual from 'lodash/isEqual';
import { useState, type FC } from 'react';

import { MultipleSelect } from '@app/components';
import { maxLength, minLength, PREFIX } from '@app/constants';
import {
  ACTION_FILTER_DATA,
  STATUS_FILTER_DATA,
} from '@app/pages/Sendouts/SendoutReceivers/constants/filtersData';

import type {
  SendoutReceiversFilterFormProps,
  SendoutReceiversFilterFormValues,
} from '@pages/Sendouts/SendoutReceivers/types';

import '@pages/Sendouts/SendoutReceivers/styles/SendoutReceivers.desktop.scss';
import '@pages/Sendouts/SendoutReceivers/styles/SendoutReceivers.tablet.scss';
import type { BaseOptionType } from 'antd/es/select';

export const SendoutsFilterForm: FC<SendoutReceiversFilterFormProps> = ({
  setGetSendoutClientsParams,
  setPageNumber,
  setRowsPerPage,
  refetchSendoutClients,
}) => {
  const [selectedStatusOptions, setSelectedStatusOptions] = useState<
    BaseOptionType[]
  >([]);
  const [selectedActionOptions, setSelectedActionOptions] = useState<
    BaseOptionType[]
  >([]);

  const [form] = Form.useForm();

  const handleReset = () => {
    setGetSendoutClientsParams({
      SearchTerm: '',
      StatusIds: [],
      ActionIds: [],
    });
    setSelectedStatusOptions([]);
    setPageNumber(1);
    setRowsPerPage(20);
    form.resetFields();
    setSelectedActionOptions([]);
  };

  const handleSubmitForm = (values: SendoutReceiversFilterFormValues) => {
    const { SearchTerm } = values;

    const newState = {
      SearchTerm: SearchTerm || '',
      StatusIds: selectedStatusOptions.map(({ value }) => value),
      ActionIds: selectedActionOptions.map(({ value }) => value),
    };
    setGetSendoutClientsParams((prev) => {
      if (isEqual(prev, newState)) {
        refetchSendoutClients();
        return prev;
      }
      return newState;
    });
  };

  return (
    <Form
      className={`${PREFIX}sendout-receivers-filter-form`}
      form={form}
      initialValues={{
        SearchTerm: '',
        StatusIds: [],
      }}
      onFinish={handleSubmitForm}
    >
      <Flex justify="space-between" wrap>
        <Flex gap={16} wrap>
          <Form.Item
            name="SearchTerm"
            rules={[minLength(3), maxLength()]}
            className="filter-term"
          >
            <Input
              placeholder="Поиск (по имени, телефону или аккаунту)"
              addonBefore={<SearchOutlined />}
              data-testid="search-client"
            />
          </Form.Item>

          <MultipleSelect
            className="status-select"
            placeholder="Все статусы"
            allOptions={STATUS_FILTER_DATA}
            selectedOption={selectedStatusOptions}
            setSelectedOptions={setSelectedStatusOptions}
            width={100}
            dataTestId="all-status-input"
            dropdownDataTestId="status-dropdown"
            optionDataTestId="status-item"
          />

          <MultipleSelect
            className="action-select"
            placeholder="Все действия"
            allOptions={ACTION_FILTER_DATA}
            selectedOption={selectedActionOptions}
            setSelectedOptions={setSelectedActionOptions}
            width={100}
            dataTestId="all-actions-input"
            dropdownDataTestId="action-dropdown"
            optionDataTestId="action-item"
          />
        </Flex>

        <div className="buttons-container">
          <Button
            htmlType="reset"
            onClick={handleReset}
            data-testid="reset-filters"
          >
            <CloseCircleOutlined />
            Сброс
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            data-testid="search-by-filters"
          >
            <FilterOutlined />
            Поиск
          </Button>
        </div>
      </Flex>
    </Form>
  );
};
